export default function (t) {
	return {
		links: [
			{ text: t("footer_link_policy"), url: "/politica" },
			{ text: t("footer_link_terms"), url: "/termeni" },
			{ text: t("footer_link_galery"), url: "/galerie" }
		]
	}
}